import { ASK_QUESTION_KEY } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { RovoLabsConfirmedTools } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const hasConfirmedQuestionAnswer = ({ tools }: RovoLabsConfirmedTools): boolean =>
	tools.some((tool) => {
		const args = tool.data.arguments;
		return (
			tool.key === ASK_QUESTION_KEY &&
			tool.resolution?.type === 'confirmed' &&
			typeof args === 'object' &&
			args !== null &&
			'questions' in args &&
			Array.isArray(args.questions) &&
			args.questions.some(
				(question: unknown) =>
					typeof question === 'object' &&
					question !== null &&
					'skipped' in question &&
					question.skipped === false,
			)
		);
	});
